import "./instrument"
import { createRoot } from 'react-dom/client'
import { App } from './App';
import * as Sentry from "@sentry/react"

createRoot(document.getElementById('root')!).render(
    <Sentry.ErrorBoundary>
        <App />
    </Sentry.ErrorBoundary>
)